import { createFileRoute } from "@tanstack/react-router";

import OnboardingSuccess from "./-components/OnboardingSuccess";

export const Route = createFileRoute("/_authenticated/onboarding/success")({
  component: OnboardingSuccess,
  context: () => ({ permissions: "onboarding" }),
});
